import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pushEvent } from "@/utils/gtm";
import ROUTES from "@/data/Routes";

// Routes that should trigger view_item event
const VIEW_ITEM_ROUTES = [
  ROUTES.MEMBERSHIPS,
  // ROUTES.EPIGENETICS_TEST,
  // ROUTES.GENETICS_TEST,
  // ROUTES.GENOME_TESTING,
  // ROUTES.SUPPLEMENTS,
  // ROUTES.AGE_SLOWING_TEST,
  ROUTES.GIFT_COUPON,
  // ROUTES.MINI_PROGRAM,
  // ROUTES.MIDI_PROGRAM,
  // ROUTES.MAXI_PROGRAM,
  // ROUTES.BLOOD_TEST,
];

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    pushEvent("page_view", {
      page_location: window.location.href,
      page_path: location.pathname + location.search,
      page_title: document.title,
    });

    if (VIEW_ITEM_ROUTES.includes(location.pathname)) {
      pushEvent("view_item", {
        page_location: window.location.href,
        page_path: location.pathname,
        page_title: document.title,
      });
    }
  }, [location]);
}
